var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRaketebg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1020,
    height: 683,
    viewBox: "0 0 1020 683",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2009_39989)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2009_39989",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -90,
    width: 1026,
    height: 785
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M353.465 -89.3359C334.085 -58.6939 327.209 -19.3816 339.246 14.8101C351.282 49.0019 383.577 76.2981 419.788 78.4402C441.23 79.7051 461.834 84.5401 483.153 87.233C504.452 89.9259 526.097 95.0873 543.58 107.573C550.292 112.367 556.249 118.14 561.798 124.26C591.237 156.8 608.985 201.171 604.089 244.788C596.928 308.398 654.234 362.297 689.895 415.461C708.194 442.758 722.536 474.644 713.356 506.204C704.175 537.764 676.797 563.306 644.666 570.283C636.241 572.119 627.591 572.752 618.982 573.364C577.16 576.403 545.865 564.224 506.349 550.025C466.649 535.745 429.132 524.891 388.779 512.467C234.427 464.974 59.5306 540.008 -0.427338 694.952H1024.37V-89.3359H353.465Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2009_39989)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M353.465 -89.3359C334.084 -58.6939 327.209 -19.3816 339.246 14.8101C351.282 49.0019 383.577 76.2981 419.788 78.4402C441.23 79.7051 461.834 84.5401 483.153 87.233C504.452 89.9259 526.097 95.0873 543.58 107.573C550.292 112.367 556.249 118.14 561.798 124.26C591.237 156.8 608.985 201.171 604.089 244.788C596.928 308.398 654.234 362.297 689.895 415.461C708.194 442.758 722.536 474.644 713.356 506.204C704.175 537.764 676.797 563.306 644.666 570.283C636.241 572.119 627.591 572.752 618.982 573.364C577.16 576.403 545.865 564.224 506.349 550.025C466.649 535.745 429.132 524.891 388.779 512.467C234.427 464.974 59.5306 540.008 -0.427353 694.952H1024.37V-89.3359H353.465Z",
    fill: "url(#paint0_radial_2009_39989)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M836.944 262.879L870.748 312.269C870.952 312.636 871.217 313.004 871.503 313.35C873.91 316.145 878.133 316.472 880.948 314.065C883.743 311.657 884.07 307.434 881.662 304.619C881.377 304.272 881.05 303.987 880.724 303.721L836.964 262.899L836.944 262.879Z",
    fill: "url(#paint1_linear_2009_39989)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M841.799 268.555L871.462 311.845C871.646 312.172 871.87 312.478 872.115 312.784C874.216 315.232 877.909 315.517 880.357 313.396C882.805 311.294 883.091 307.602 880.969 305.154C880.724 304.868 880.438 304.603 880.132 304.358L841.779 268.555H841.799Z",
    fill: "url(#paint2_linear_2009_39989)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M873.074 304.926C875.216 303.09 878.46 303.314 880.296 305.476C882.132 307.619 881.907 310.862 879.745 312.698C877.582 314.534 874.359 314.31 872.523 312.148C870.666 310.005 870.911 306.762 873.074 304.926Z",
    fill: "url(#paint3_linear_2009_39989)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.485 34.053H411.832C411.261 34.0326 410.751 34.155 410.261 34.3998C409.751 34.563 409.323 34.8486 408.955 35.2362C408.547 35.6034 408.282 36.0523 408.119 36.5419C407.854 37.0315 407.752 37.5619 407.772 38.1127L407.915 39.194C408.119 39.8876 408.466 40.4792 408.955 40.9892L409.771 41.6217C410.404 41.9889 411.097 42.1725 411.832 42.1725H412.485C413.056 42.1929 413.566 42.0705 414.056 41.8257C414.566 41.6625 414.994 41.3769 415.361 40.9892C415.769 40.622 416.034 40.1732 416.198 39.6836C416.463 39.194 416.565 38.6636 416.544 38.1127L416.402 37.0315C416.198 36.3379 415.851 35.7462 415.361 35.2362L414.545 34.6038C413.913 34.2366 413.219 34.053 412.485 34.053Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.852 225.477C861.115 225.477 861.115 217.316 855.852 217.316C850.589 217.316 850.589 225.477 855.852 225.477Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.847 316.617C374.111 316.617 374.111 308.457 368.847 308.457C363.584 308.457 363.584 316.617 368.847 316.617Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.905 478.617C893.168 478.617 893.168 470.457 887.905 470.457C882.642 470.457 882.642 478.617 887.905 478.617Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.537 504.879C725.8 504.879 725.8 496.719 720.537 496.719C715.273 496.719 715.273 504.879 720.537 504.879Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.687 75.275C361.911 75.0506 362.136 74.8262 362.34 74.6222C362.544 74.4386 362.686 74.2142 362.768 73.9694C362.89 73.7246 362.952 73.4594 362.952 73.1738C362.952 72.8882 362.911 72.6229 362.768 72.3781C362.686 72.1333 362.544 71.9089 362.34 71.7253L361.932 71.3989C361.605 71.2153 361.279 71.1133 360.912 71.1133L360.361 71.1949C360.014 71.2969 359.708 71.4601 359.463 71.7253C359.239 71.9497 359.014 72.1741 358.81 72.3781C358.606 72.5617 358.463 72.7861 358.382 73.0309C358.259 73.2758 358.198 73.541 358.198 73.8266C358.198 74.1122 358.239 74.3774 358.382 74.6222C358.463 74.867 358.606 75.0914 358.81 75.275L359.218 75.6014C359.545 75.7851 359.871 75.8871 360.238 75.8871L360.789 75.8055C361.136 75.7035 361.442 75.5403 361.687 75.275Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.36 169.1C309.991 169.1 309.991 165.02 307.36 165.02C304.728 165.02 304.728 169.1 307.36 169.1Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.531 565.834C513.163 565.834 513.163 561.754 510.531 561.754C507.899 561.754 507.899 565.834 510.531 565.834Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.906 419.703H320.559C320.844 419.703 321.11 419.662 321.354 419.519C321.599 419.438 321.824 419.295 322.007 419.091C322.211 418.907 322.354 418.683 322.436 418.438C322.558 418.193 322.619 417.928 322.619 417.643L322.538 417.092C322.436 416.745 322.272 416.439 322.007 416.194L321.599 415.868C321.273 415.684 320.946 415.582 320.579 415.582H319.926C319.641 415.582 319.376 415.623 319.131 415.766C318.886 415.847 318.662 415.99 318.478 416.194C318.274 416.378 318.131 416.602 318.049 416.847C317.927 417.092 317.866 417.357 317.866 417.643L317.948 418.193C318.05 418.54 318.213 418.846 318.478 419.091L318.886 419.417C319.212 419.601 319.539 419.703 319.906 419.703Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.964 491.131C275.595 491.131 275.595 487.051 272.964 487.051C270.332 487.051 270.332 491.131 272.964 491.131Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.969 540.213C374.601 540.213 374.601 536.133 371.969 536.133C369.337 536.133 369.337 540.213 371.969 540.213Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.942 610.15C845.573 610.15 845.573 606.07 842.942 606.07C840.31 606.07 840.31 610.15 842.942 610.15Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.928 275.287C882.56 275.287 882.56 271.207 879.928 271.207C877.297 271.207 877.297 275.287 879.928 275.287Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.401 28.8223C703.033 28.8223 703.033 24.7422 700.401 24.7422C697.77 24.7422 697.77 28.8223 700.401 28.8223Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.829 52.5674C534.135 52.5674 534.135 50.5273 532.829 50.5273C531.523 50.5273 531.523 52.5674 532.829 52.5674Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.497 33.1484H489.845C489.702 33.1484 489.579 33.1688 489.457 33.23C489.335 33.2708 489.212 33.332 489.131 33.434C489.029 33.5361 488.967 33.6381 488.927 33.7605C488.865 33.8829 488.825 34.0053 488.845 34.1481L488.886 34.4133C488.927 34.5765 489.029 34.7397 489.151 34.8621L489.355 35.0253C489.518 35.1273 489.681 35.1681 489.865 35.1681H490.518C490.661 35.1681 490.783 35.1477 490.905 35.0865C491.028 35.0457 491.15 34.9845 491.232 34.8825C491.334 34.7805 491.395 34.6785 491.436 34.5561C491.497 34.4337 491.538 34.3113 491.517 34.1685L491.477 33.9033C491.436 33.7401 491.334 33.5768 491.211 33.4544L491.007 33.2912C490.844 33.1892 490.681 33.1484 490.497 33.1484Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.247 83.2588C450.553 83.2588 450.553 81.2188 449.247 81.2188C447.941 81.2188 447.941 83.2588 449.247 83.2588Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.783 109.899C378.089 109.899 378.089 107.859 376.783 107.859C375.478 107.859 375.478 109.899 376.783 109.899Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.847 164.122H370.174C370.439 164.122 370.704 164 370.888 163.816C370.99 163.714 371.051 163.612 371.092 163.49C371.153 163.367 371.194 163.245 371.173 163.102C371.173 162.837 371.071 162.572 370.867 162.388C370.663 162.204 370.418 162.082 370.153 162.082H368.827C368.562 162.082 368.297 162.204 368.113 162.388C368.011 162.49 367.95 162.592 367.909 162.714C367.848 162.837 367.807 162.959 367.827 163.102C367.827 163.367 367.929 163.632 368.133 163.816C368.337 164 368.582 164.122 368.847 164.122Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.433 560.532C442.739 560.532 442.739 558.492 441.433 558.492C440.128 558.492 440.128 560.532 441.433 560.532Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.716 21.3772C279.268 21.6016 278.839 21.826 278.39 22.03C278.268 22.0912 278.166 22.1728 278.105 22.2952C278.023 22.3972 277.962 22.5196 277.921 22.642C277.88 22.7848 277.88 22.9072 277.921 23.05C277.921 23.1929 277.962 23.3153 278.044 23.4377C278.186 23.6621 278.39 23.8457 278.656 23.9069L278.921 23.9477C279.104 23.9477 279.268 23.9069 279.431 23.8049C279.88 23.5805 280.308 23.3561 280.757 23.152C280.879 23.0908 280.981 23.0092 281.042 22.8868C281.124 22.7848 281.185 22.6624 281.226 22.54C281.267 22.3972 281.267 22.2748 281.226 22.132C281.226 21.9892 281.185 21.8668 281.104 21.7444C280.961 21.52 280.757 21.3364 280.492 21.2752L280.226 21.2344C280.043 21.2344 279.88 21.2752 279.716 21.3772Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.73 138.014C1021.29 138.238 1020.86 138.463 1020.41 138.667C1020.29 138.728 1020.18 138.81 1020.12 138.932C1020.04 139.034 1019.98 139.156 1019.94 139.279C1019.9 139.422 1019.9 139.544 1019.94 139.687C1019.94 139.83 1019.98 139.952 1020.06 140.074C1020.2 140.299 1020.41 140.482 1020.67 140.544L1020.94 140.584C1021.12 140.584 1021.29 140.544 1021.45 140.442C1021.9 140.217 1022.33 139.993 1022.77 139.789C1022.9 139.728 1023 139.646 1023.06 139.524C1023.14 139.422 1023.2 139.299 1023.24 139.177C1023.28 139.034 1023.28 138.912 1023.24 138.769C1023.24 138.626 1023.2 138.504 1023.12 138.381C1022.98 138.157 1022.77 137.973 1022.51 137.912L1022.24 137.871C1022.06 137.871 1021.9 137.912 1021.73 138.014Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.829 50.3281H249.176C249.034 50.3281 248.911 50.3485 248.789 50.4097C248.666 50.4505 248.544 50.5117 248.462 50.6137C248.36 50.7157 248.299 50.8178 248.258 50.9402C248.197 51.0626 248.156 51.185 248.177 51.3278L248.218 51.593C248.258 51.7562 248.36 51.9194 248.483 52.0418L248.687 52.205C248.85 52.307 249.013 52.3478 249.197 52.3478H249.85C249.992 52.3478 250.115 52.3274 250.237 52.2662C250.36 52.2254 250.482 52.1642 250.564 52.0622C250.666 51.9602 250.727 51.8582 250.768 51.7358C250.829 51.6134 250.87 51.491 250.849 51.3482L250.808 51.083C250.768 50.9198 250.666 50.7565 250.543 50.6341L250.339 50.4709C250.176 50.3689 250.013 50.3281 249.829 50.3281Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.183 81.4815C287.489 81.4815 287.489 79.4414 286.183 79.4414C284.878 79.4414 284.878 81.4815 286.183 81.4815Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.119 282.485C297.424 282.485 297.424 280.445 296.119 280.445C294.813 280.445 294.813 282.485 296.119 282.485Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.052 307.845C254.827 308.07 254.603 308.294 254.399 308.498C254.297 308.6 254.236 308.702 254.195 308.824C254.134 308.947 254.093 309.069 254.113 309.212C254.113 309.355 254.134 309.477 254.195 309.6C254.236 309.722 254.297 309.844 254.399 309.926L254.603 310.089C254.766 310.191 254.929 310.232 255.113 310.232L255.378 310.191C255.542 310.15 255.705 310.048 255.827 309.926C256.052 309.702 256.276 309.477 256.48 309.273C256.582 309.171 256.643 309.069 256.684 308.947C256.745 308.824 256.786 308.702 256.766 308.559C256.766 308.416 256.745 308.294 256.684 308.172C256.643 308.049 256.582 307.927 256.48 307.845L256.276 307.682C256.113 307.58 255.95 307.539 255.766 307.539L255.501 307.58C255.337 307.621 255.174 307.723 255.052 307.845Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.808 355.156H251.155C251.013 355.156 250.89 355.177 250.768 355.238C250.645 355.279 250.523 355.34 250.441 355.442C250.339 355.544 250.278 355.646 250.237 355.768C250.176 355.891 250.135 356.013 250.156 356.156L250.196 356.421C250.237 356.584 250.339 356.748 250.462 356.87L250.666 357.033C250.829 357.135 250.992 357.176 251.176 357.176H251.829C251.971 357.176 252.094 357.156 252.216 357.094C252.339 357.054 252.461 356.992 252.543 356.89C252.645 356.788 252.706 356.686 252.747 356.564C252.808 356.442 252.849 356.319 252.828 356.176L252.787 355.911C252.747 355.748 252.645 355.585 252.522 355.462L252.318 355.299C252.155 355.197 251.992 355.156 251.808 355.156Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.36 355.22C308.665 355.22 308.665 353.18 307.36 353.18C306.054 353.18 306.054 355.22 307.36 355.22Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.693 465.63C346.998 465.63 346.998 463.59 345.693 463.59C344.387 463.59 344.387 465.63 345.693 465.63Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.226 539.024C283.531 539.024 283.531 536.984 282.226 536.984C280.92 536.984 280.92 539.024 282.226 539.024Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.155 578.032C252.461 578.032 252.461 575.992 251.155 575.992C249.85 575.992 249.85 578.032 251.155 578.032Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.796 646.204C103.102 646.204 103.102 644.164 101.796 644.164C100.49 644.164 100.49 646.204 101.796 646.204Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.342 617.135C198.181 617.135 198.181 606.449 191.342 606.449C184.503 606.449 184.503 617.135 191.342 617.135Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.542 632.894C287.574 632.894 287.574 626.594 283.542 626.594C279.509 626.594 279.509 632.894 283.542 632.894Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.948 580.625H315.295C315.153 580.625 315.03 580.645 314.908 580.707C314.785 580.747 314.663 580.809 314.581 580.911C314.479 581.013 314.418 581.115 314.377 581.237C314.316 581.359 314.275 581.482 314.296 581.625L314.337 581.89C314.377 582.053 314.479 582.216 314.602 582.339L314.806 582.502C314.969 582.604 315.132 582.645 315.316 582.645H315.969C316.111 582.645 316.234 582.624 316.356 582.563C316.479 582.522 316.601 582.461 316.683 582.359C316.785 582.257 316.846 582.155 316.887 582.033C316.948 581.91 316.989 581.788 316.968 581.645L316.927 581.38C316.887 581.217 316.785 581.053 316.662 580.931L316.458 580.768C316.295 580.666 316.132 580.625 315.948 580.625Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.951 65.9971C762.256 65.9971 762.256 63.957 760.951 63.957C759.645 63.957 759.645 65.9971 760.951 65.9971Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.887 81.626C826.192 81.626 826.192 79.5859 824.887 79.5859C823.581 79.5859 823.581 81.626 824.887 81.626Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.896 195.868C969.202 195.868 969.202 193.828 967.896 193.828C966.591 193.828 966.591 195.868 967.896 195.868Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.698 172.829C898.003 172.829 898.003 170.789 896.698 170.789C895.392 170.789 895.392 172.829 896.698 172.829Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.183 17.337C853.489 17.337 853.489 15.2969 852.183 15.2969C850.877 15.2969 850.877 17.337 852.183 17.337Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.045 533.177C783.351 533.177 783.351 531.137 782.045 531.137C780.74 531.137 780.74 533.177 782.045 533.177Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.939 614.411C739.244 614.411 739.244 612.371 737.939 612.371C736.633 612.371 736.633 614.411 737.939 614.411Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.541 390.204C934.847 390.204 934.847 388.164 933.541 388.164C932.236 388.164 932.236 390.204 933.541 390.204Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.245 550.11C852.55 550.11 852.55 548.07 851.245 548.07C849.939 548.07 849.939 550.11 851.245 550.11Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.201 446.41H970.549C970.406 446.41 970.283 446.431 970.161 446.492C970.039 446.533 969.916 446.594 969.835 446.696C969.733 446.798 969.671 446.9 969.631 447.022C969.569 447.145 969.529 447.267 969.549 447.41L969.59 447.675C969.631 447.838 969.733 448.001 969.855 448.124L970.059 448.287C970.222 448.389 970.385 448.43 970.569 448.43H971.222C971.365 448.43 971.487 448.409 971.609 448.348C971.732 448.307 971.854 448.246 971.936 448.144C972.038 448.042 972.099 447.94 972.14 447.818C972.201 447.695 972.242 447.573 972.221 447.43L972.181 447.165C972.14 447.002 972.038 446.839 971.915 446.716L971.711 446.553C971.548 446.451 971.385 446.41 971.201 446.41Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.097 524.896C976.873 525.12 976.648 525.345 976.444 525.549C976.342 525.651 976.281 525.753 976.24 525.875C976.179 525.998 976.138 526.12 976.159 526.263C976.159 526.406 976.179 526.528 976.24 526.65C976.281 526.773 976.342 526.895 976.444 526.977L976.648 527.14C976.812 527.242 976.975 527.283 977.158 527.283L977.424 527.242C977.587 527.201 977.75 527.099 977.872 526.977C978.097 526.752 978.321 526.528 978.525 526.324C978.627 526.222 978.689 526.12 978.729 525.998C978.791 525.875 978.831 525.753 978.811 525.61C978.811 525.467 978.791 525.345 978.729 525.222C978.689 525.1 978.627 524.977 978.525 524.896L978.321 524.733C978.158 524.631 977.995 524.59 977.811 524.59L977.546 524.631C977.383 524.671 977.22 524.773 977.097 524.896Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.563 549.614C930.869 549.614 930.869 547.574 929.563 547.574C928.258 547.574 928.258 549.614 929.563 549.614Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.06 622.349C910.366 622.349 910.366 620.309 909.06 620.309C907.755 620.309 907.755 622.349 909.06 622.349Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.102 612.005C400.407 612.005 400.407 609.965 399.102 609.965C397.796 609.965 397.796 612.005 399.102 612.005Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.897 649.317C347.202 649.317 347.202 647.277 345.897 647.277C344.591 647.277 344.591 649.317 345.897 649.317Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.683 475.321C428.989 475.321 428.989 473.281 427.683 473.281C426.378 473.281 426.378 475.321 427.683 475.321Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.103 239.81V239.157C340.103 239.014 340.082 238.892 340.021 238.77C339.98 238.647 339.919 238.525 339.817 238.443C339.715 238.341 339.613 238.28 339.491 238.239C339.368 238.178 339.246 238.137 339.103 238.158L338.838 238.198C338.675 238.239 338.511 238.341 338.389 238.464L338.226 238.668C338.124 238.831 338.083 238.994 338.083 239.178V239.831C338.083 239.973 338.103 240.096 338.165 240.218C338.205 240.341 338.267 240.463 338.369 240.545C338.471 240.647 338.573 240.708 338.695 240.749C338.818 240.81 338.94 240.851 339.083 240.83L339.348 240.789C339.511 240.749 339.674 240.647 339.797 240.524L339.96 240.32C340.062 240.157 340.103 239.994 340.103 239.81Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.133 186.236V185.583C256.133 185.44 256.113 185.318 256.052 185.195C256.011 185.073 255.949 184.951 255.847 184.869C255.745 184.767 255.643 184.706 255.521 184.665C255.399 184.604 255.276 184.563 255.133 184.583L254.868 184.624C254.705 184.665 254.542 184.767 254.419 184.889L254.256 185.093C254.154 185.257 254.113 185.42 254.113 185.603V186.256C254.113 186.399 254.134 186.521 254.195 186.644C254.236 186.766 254.297 186.889 254.399 186.97C254.501 187.072 254.603 187.134 254.725 187.174C254.848 187.236 254.97 187.276 255.113 187.256L255.378 187.215C255.541 187.174 255.705 187.072 255.827 186.95L255.99 186.746C256.092 186.583 256.133 186.419 256.133 186.236Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.341 119.773H470.688C470.545 119.773 470.423 119.794 470.301 119.855C470.178 119.896 470.056 119.957 469.974 120.059C469.872 120.161 469.811 120.263 469.77 120.385C469.709 120.508 469.668 120.63 469.689 120.773L469.729 121.038C469.77 121.201 469.872 121.365 469.995 121.487L470.199 121.65C470.362 121.752 470.525 121.793 470.709 121.793H471.361C471.504 121.793 471.627 121.773 471.749 121.712C471.871 121.671 471.994 121.61 472.075 121.508C472.177 121.405 472.239 121.304 472.28 121.181C472.341 121.059 472.381 120.936 472.361 120.793L472.32 120.528C472.28 120.365 472.177 120.202 472.055 120.079L471.851 119.916C471.688 119.814 471.525 119.773 471.341 119.773Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.838 406.747C397.143 406.747 397.143 404.707 395.838 404.707C394.532 404.707 394.532 406.747 395.838 406.747Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.341 335.63C472.647 335.63 472.647 333.59 471.341 333.59C470.035 333.59 470.035 335.63 471.341 335.63Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.461 274.755C422.767 274.755 422.767 272.715 421.461 272.715C420.156 272.715 420.156 274.755 421.461 274.755Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.21 190.603C440.515 190.603 440.515 188.562 439.21 188.562C437.904 188.562 437.904 190.603 439.21 190.603Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.458 148.884C544.763 148.884 544.763 146.844 543.458 146.844C542.152 146.844 542.152 148.884 543.458 148.884Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.67 406.587C804.976 406.587 804.976 404.547 803.67 404.547C802.364 404.547 802.364 406.587 803.67 406.587Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.752 550.11C691.058 550.11 691.058 548.07 689.752 548.07C688.446 548.07 688.446 550.11 689.752 550.11Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.632 427.864C739.938 427.864 739.938 425.824 738.632 425.824C737.327 425.824 737.327 427.864 738.632 427.864Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.084 577.524C619.39 577.524 619.39 575.484 618.084 575.484C616.778 575.484 616.778 577.524 618.084 577.524Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.091 242.153C713.396 242.153 713.396 240.113 712.091 240.113C710.785 240.113 710.785 242.153 712.091 242.153Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.851 342.079C870.156 342.079 870.156 340.039 868.851 340.039C867.545 340.039 867.545 342.079 868.851 342.079Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.495 335.63C781.8 335.63 781.8 333.59 780.495 333.59C779.189 333.59 779.189 335.63 780.495 335.63Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.194 634.892C483.5 634.892 483.5 632.852 482.194 632.852C480.889 632.852 480.889 634.892 482.194 634.892Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.78 518.345C556.086 518.345 556.086 516.305 554.78 516.305C553.475 516.305 553.475 518.345 554.78 518.345Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.878 398.489C511.184 398.489 511.184 396.449 509.878 396.449C508.573 396.449 508.573 398.489 509.878 398.489Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.664 479.075C820.97 479.075 820.97 477.035 819.664 477.035C818.359 477.035 818.359 479.075 819.664 479.075Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.018 428.126C859.323 428.126 859.323 426.086 858.018 426.086C856.712 426.086 856.712 428.126 858.018 428.126Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.368 262.919C793.674 262.919 793.674 260.879 792.368 260.879C791.062 260.879 791.062 262.919 792.368 262.919Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.569 421.95C689.874 421.95 689.874 419.91 688.569 419.91C687.263 419.91 687.263 421.95 688.569 421.95Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.481 375.618C594.786 375.618 594.786 373.578 593.481 373.578C592.175 373.578 592.175 375.618 593.481 375.618Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.1 335.63C630.406 335.63 630.406 333.59 629.1 333.59C627.795 333.59 627.795 335.63 629.1 335.63Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.906 292.501C660.212 292.501 660.212 290.461 658.906 290.461C657.6 290.461 657.6 292.501 658.906 292.501Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.481 292.501C594.786 292.501 594.786 290.461 593.481 290.461C592.175 290.461 592.175 292.501 593.481 292.501Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.785 126.036C769.091 126.036 769.091 123.996 767.785 123.996C766.479 123.996 766.479 126.036 767.785 126.036Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.591 92.0088C684.897 92.0088 684.897 89.9688 683.591 89.9688C682.285 89.9688 682.285 92.0088 683.591 92.0088Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.975 37.1885C638.281 37.1885 638.281 35.1484 636.975 35.1484C635.669 35.1484 635.669 37.1885 636.975 37.1885Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.834 100.677C578.139 100.677 578.139 98.6367 576.834 98.6367C575.528 98.6367 575.528 100.677 576.834 100.677Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.878 17.9297H567.225C567.082 17.9297 566.96 17.9501 566.837 18.0113C566.715 18.0521 566.592 18.1133 566.511 18.2153C566.409 18.3173 566.348 18.4193 566.307 18.5417C566.246 18.6641 566.205 18.7865 566.225 18.9293L566.266 19.1945C566.307 19.3577 566.409 19.5209 566.531 19.6433L566.735 19.8066C566.898 19.9086 567.062 19.9494 567.245 19.9494H567.898C568.041 19.9494 568.163 19.929 568.286 19.8678C568.408 19.827 568.531 19.7658 568.612 19.6638C568.714 19.5617 568.775 19.4597 568.816 19.3373C568.877 19.2149 568.918 19.0925 568.898 18.9497L568.857 18.6845C568.816 18.5213 568.714 18.3581 568.592 18.2357L568.388 18.0725C568.224 17.9705 568.061 17.9297 567.878 17.9297Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.244 -1.89844H399.918C399.653 -1.89844 399.387 -1.77604 399.204 -1.59243C399.102 -1.49043 399.041 -1.38842 399 -1.26602C398.939 -1.14361 398.898 -1.0212 398.918 -0.878398C398.918 -0.613187 399.02 -0.34798 399.224 -0.164373C399.428 0.0192344 399.673 0.141642 399.938 0.141642H401.264C401.53 0.141642 401.795 0.0192344 401.978 -0.164373C402.08 -0.266377 402.142 -0.36838 402.182 -0.490785C402.244 -0.61319 402.284 -0.735592 402.264 -0.878398C402.264 -1.14361 402.162 -1.40882 401.958 -1.59243C401.754 -1.77604 401.509 -1.89844 401.244 -1.89844Z",
    fill: "#FFF6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.324 20.582H349.671C349.528 20.582 349.405 20.6024 349.283 20.6636C349.161 20.7044 349.038 20.7656 348.957 20.8676C348.855 20.9696 348.793 21.0716 348.753 21.1941C348.691 21.3165 348.651 21.4389 348.671 21.5817L348.712 21.8469C348.753 22.0101 348.855 22.1733 348.977 22.2957L349.181 22.4589C349.344 22.5609 349.508 22.6017 349.691 22.6017H350.344C350.487 22.6017 350.609 22.5813 350.732 22.5201C350.854 22.4793 350.976 22.4181 351.058 22.3161C351.16 22.2141 351.221 22.1121 351.262 21.9897C351.323 21.8673 351.364 21.7449 351.344 21.6021L351.303 21.3369C351.262 21.1737 351.16 21.0104 351.038 20.888L350.834 20.7248C350.67 20.6228 350.507 20.582 350.324 20.582Z",
    fill: "#FFF6E3"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M869.985 157.715C880.816 127.283 864.925 93.832 834.492 83.0013C804.06 72.1706 770.609 88.0614 759.778 118.494C748.948 148.927 764.838 182.378 795.271 193.208C825.704 204.039 859.155 188.148 869.985 157.715Z",
    fill: "#BBAEFF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M857.753 153.117C867.71 124.826 854.61 94.0287 828.276 81.1825C830.471 81.679 832.667 82.2855 834.84 83.0587C865.311 93.7698 881.31 127.164 870.599 157.635C859.888 188.106 826.486 204.124 796.022 193.394C793.849 192.621 791.766 191.73 789.74 190.752C818.295 197.215 847.815 181.414 857.772 153.124L857.753 153.117Z",
    fill: "#6928FF"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M856.398 179.281C849.319 177.302 842.199 175.098 834.936 174.588C823.94 173.813 813.107 176.955 802.438 179.75C794.951 181.708 787.341 183.504 779.691 184.83C772.632 179.505 766.818 172.61 762.779 164.694C773.713 162.022 784.873 159.451 795.624 162.287C801.214 163.756 806.334 166.632 811.7 168.774C826.409 174.609 843.341 174.65 858.091 168.897C860.968 167.775 863.783 166.449 866.659 165.326C863.946 170.508 860.458 175.2 856.398 179.321V179.281ZM766.981 104.552C764.431 108.204 762.269 112.142 760.596 116.344C764.594 120.465 768.511 124.668 773.183 127.973C780.18 132.91 788.728 135.582 797.276 135.5C815.066 135.337 831.182 123.811 848.972 123.321C856.887 123.097 864.64 125.096 872.331 127.136C870.209 115.977 864.925 105.919 857.377 97.9426C840.138 100.146 824.858 114.08 807.109 116.099C792.992 117.711 779.568 111.672 766.981 104.573V104.552ZM789.85 85.2533C794.073 86.5386 798.378 87.4974 802.805 87.8646C812.536 88.6603 822.267 86.5182 831.529 83.4173C832.223 83.1928 832.916 82.9276 833.61 82.6828C828.428 80.9488 822.941 79.8879 817.187 79.6635C807.416 79.2759 798.133 81.3364 789.871 85.2533H789.85Z",
    fill: "#FFD079"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M758.882 121.225C751.497 124.652 730.362 132.507 736.339 141.544C738.93 145.441 743.785 147.664 748.457 149.46C787.423 164.434 832.488 164.781 872.861 154.009C873.8 153.764 874.738 153.499 875.677 153.234C881.776 151.52 889.814 149.031 892.732 143.482C896.057 137.178 889.916 130.813 884.837 126.957C884.592 126.774 884.367 126.611 884.123 126.427C882.388 125.162 874.636 120.348 870.27 119.389L867.292 112.208C882.511 116.798 924.21 131.303 911.623 151.54C908.971 155.825 904.768 159.211 900.26 162.047C889.1 169.126 876.044 173.614 862.641 176.287C831.121 182.611 796.95 181.713 765.941 173.716C751.538 170.003 737.686 164.128 726.424 155.355C717.02 148.052 710.063 137.199 719.407 127.61C725.568 121.286 734.87 117.41 743.541 114.493C746.376 113.534 761.269 109.494 764.207 108.801L758.821 121.204L758.882 121.225Z",
    fill: "url(#paint4_linear_2009_39989)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M911.664 144.258C909.052 148.563 904.809 151.929 900.3 154.765C889.141 161.844 876.085 166.332 862.681 169.004C831.162 175.329 796.991 174.431 765.982 166.434C751.579 162.721 737.726 156.845 726.465 148.073C721.385 144.136 717.02 139.138 715.551 133.895C713.184 141.688 719.08 149.624 726.465 155.356C737.726 164.108 751.579 170.004 765.982 173.717C796.991 181.714 831.162 182.612 862.681 176.287C876.064 173.594 889.141 169.127 900.3 162.048C904.789 159.192 909.032 155.846 911.664 151.541C914.132 147.461 914.54 143.646 913.5 140.137C913.112 141.484 912.5 142.85 911.664 144.258Z",
    fill: "url(#paint5_linear_2009_39989)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M343.714 25.3759C344.203 27.7016 353.077 33.1486 355.22 34.2502C360.259 36.8207 365.461 39.0648 370.806 40.9417C381.027 44.5526 392.145 47.2047 402.937 48.1228C433.946 50.7953 464.813 42.7369 495.863 44.3486C525.566 45.8991 554.862 54.9366 580.22 70.4412C601.212 83.2733 623.857 102.246 635.935 124.136C642.034 135.173 648.257 145.985 652.194 158.124C656.417 171.14 658.865 184.645 660.844 198.15C664.741 224.794 665.822 253.273 680.266 276.877C687.365 288.465 697.565 296.666 706.97 306.519C780.556 383.675 807.913 516.892 711.336 588.275C709.663 589.519 707.949 590.723 706.215 591.906C676.022 612.327 638.607 621.61 602.355 618.243C566.245 614.898 530.768 608.92 495.251 602.392C459.202 595.782 440.179 582.212 390.717 569.649C151.59 527.291 45.3113 638.857 -0.447708 681.291C-20.0325 699.468 -34.0274 723.235 -44.2278 747.716C-49.124 759.446 -53.1634 771.503 -56.3663 783.805C-57.6107 788.599 -58.7736 793.577 -60.1405 798.33L-0.448013 694.93C0.694431 694.93 3.44854 676.773 4.32578 674.917C7.34509 668.695 13.6693 658.943 16.9743 652.864C23.5841 640.786 31.4588 630.198 39.4355 618.978C54.981 597.108 76.769 573.688 99.0467 558.551C123.018 542.271 143.949 529.316 171.041 518.953C228.939 496.798 295.404 486.801 355.566 502.632C385.923 510.629 419.176 521.503 449.165 530.948C479.767 540.578 498.862 547.351 531.075 558.816C553.944 566.956 589.788 573.341 614.126 573.627C637.057 573.872 654.887 563.059 675.329 552.451C692.098 543.76 696.423 537.456 704.44 520.34C717.028 493.493 717.966 465.992 703.074 442.225C695.607 430.291 688.059 417.255 679.756 405.892C671.085 393.998 663.088 381.594 655.825 368.783C640.729 342.159 608.965 319.617 599.907 290.382C592.767 267.309 603.987 239.686 600.927 215.879C597.928 192.438 589.564 172.751 578.67 151.575C559.676 114.629 519.874 92.5761 487.58 87.8227C460.202 83.7833 434.844 82.0289 407.731 76.7655C394.103 74.1134 379.578 67.9931 369.378 58.568C359.279 49.2448 351.486 38.6976 343.673 25.3555L343.714 25.3759Z",
    fill: "#1E0659"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M399.061 764.993C320.763 625.452 361.32 451.555 487.845 359.895C476.768 364.526 465.833 369.748 455.102 375.766C304.83 460.083 251.38 650.259 335.696 800.531C420.013 950.804 610.189 1004.25 760.461 919.937C771.192 913.919 781.352 907.309 791.062 900.271C646.91 960.514 477.339 904.535 399.041 764.993H399.061Z",
    fill: "#9980FF"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M811.089 488.157C809.89 486.503 808.666 484.888 807.417 483.285C807.278 483.348 807.139 483.411 807 483.474C808.389 485.002 809.739 486.566 811.089 488.157Z",
    fill: "url(#paint6_linear_2009_39989)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M867.582 628.023C913.289 628.023 950.342 590.971 950.342 545.264C950.342 499.557 913.289 462.504 867.582 462.504C821.875 462.504 784.822 499.557 784.822 545.264C784.822 590.971 821.875 628.023 867.582 628.023Z",
    fill: "#BBAEFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M948.134 564.215C938.122 567.077 927.905 569.675 918.776 574.426C904.938 581.618 894.185 593.432 883.395 604.693C875.824 612.594 867.982 620.398 859.708 627.639C847.24 626.437 835.145 622.422 824.408 615.868C835.632 604.558 847.18 593.188 862.246 588.648C870.087 586.289 878.378 585.975 886.441 584.562C908.51 580.704 928.955 568.241 942.495 550.399C945.136 546.919 947.538 543.228 950.174 539.749C950.72 548.007 950.012 556.254 948.139 564.22L948.134 564.215ZM784.99 540.257C784.606 546.546 784.92 552.899 786.002 559.209C793.87 561.211 801.712 563.397 809.786 563.917C821.865 564.696 834.165 561.585 844.426 555.161C865.753 541.805 876.679 515.965 897.757 502.208C907.146 496.082 917.964 492.749 928.76 489.534C917.953 477.65 904.116 469.414 889.131 465.372C869.968 480.789 861.84 508.886 841.925 524.472C826.102 536.853 805.44 539.516 784.99 540.252V540.257ZM798.27 500.055C804.326 498.48 810.224 496.45 815.814 493.62C828.126 487.386 838.294 477.586 847.158 467.006C847.819 466.216 848.468 465.404 849.117 464.598C841.584 466.324 834.165 469.122 827.087 473.099C815.024 479.869 805.332 489.22 798.275 500.06L798.27 500.055Z",
    fill: "#FFD079"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M928.836 489.578C931.006 491.981 933.068 494.541 935 497.236C948.967 492.176 958.129 490.59 959.779 493.534C961.43 496.478 955.288 503.481 943.691 512.767C928.376 525.052 903.51 541.362 874.514 557.635C845.535 573.897 818.661 586.619 800.191 593.292C786.224 598.352 777.046 599.943 775.395 597.004C773.745 594.06 779.87 587.069 791.462 577.782C790.169 574.73 789.059 571.64 788.139 568.534C748.418 595.094 723.92 616.8 727.8 623.716C731.68 630.632 762.965 621.01 806.328 600.944C827.899 590.97 852.446 578.421 878.097 564.026C903.748 549.631 927.266 535.209 947.019 521.994C986.74 495.434 1011.25 473.744 1007.37 466.828C1003.49 459.912 972.194 469.518 928.83 489.584L928.836 489.578Z",
    fill: "url(#paint7_linear_2009_39989)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.37 466.736C1006.77 465.654 1005.49 464.977 1003.61 464.68C1001.34 473.717 978.13 493.372 943.041 516.831C923.289 530.047 899.77 544.468 874.119 558.863C848.468 573.258 823.921 585.808 802.35 595.781C765.757 612.714 737.768 622.206 727.583 620.604C727.286 621.8 727.345 622.812 727.8 623.619C731.68 630.535 762.965 620.913 806.328 600.847C827.898 590.873 852.446 578.323 878.097 563.929C903.748 549.534 927.266 535.112 947.019 521.897C986.74 495.336 1011.25 473.647 1007.37 466.731L1007.37 466.736Z",
    fill: "url(#paint8_linear_2009_39989)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M757.819 464.594L771.827 482.944C771.916 483.083 772.017 483.221 772.143 483.348C773.127 484.382 774.768 484.42 775.79 483.436C776.825 482.452 776.863 480.811 775.878 479.789C775.765 479.662 775.626 479.549 775.5 479.461L757.819 464.606V464.594Z",
    fill: "url(#paint9_linear_2009_39989)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M759.813 466.676L772.105 482.754C772.181 482.88 772.269 482.994 772.383 483.107C773.241 484.004 774.667 484.041 775.576 483.183C776.472 482.325 776.509 480.899 775.651 479.99C775.55 479.877 775.437 479.788 775.311 479.7L759.813 466.676Z",
    fill: "url(#paint10_linear_2009_39989)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M772.585 480.066C773.38 479.309 774.629 479.347 775.386 480.129C776.143 480.924 776.106 482.174 775.323 482.931C774.528 483.688 773.279 483.65 772.521 482.868C771.764 482.073 771.802 480.823 772.585 480.066Z",
    fill: "url(#paint11_linear_2009_39989)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M925.818 570.993C943.034 532.276 928.012 487.397 892.31 466.296C895.351 467.246 898.379 468.351 901.358 469.688C943.134 488.253 961.954 537.12 943.43 578.823C924.905 620.527 875.997 639.281 834.234 620.691C831.255 619.354 828.417 617.861 825.669 616.252C865.22 628.614 908.627 609.723 925.844 571.005L925.818 570.993Z",
    fill: "#6928FF"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M353.161 581.582L389.475 629.136C389.699 629.504 389.985 629.85 390.291 630.177C392.841 632.849 397.084 632.951 399.757 630.401C402.429 627.851 402.531 623.608 399.981 620.935C399.675 620.609 399.349 620.323 398.981 620.078L353.161 581.582Z",
    fill: "url(#paint12_linear_2009_39989)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M358.323 586.966L390.189 628.645C390.393 628.971 390.617 629.257 390.903 629.542C393.126 631.888 396.839 631.97 399.165 629.726C401.511 627.502 401.593 623.789 399.349 621.463C399.083 621.178 398.798 620.933 398.471 620.709L358.302 586.945L358.323 586.966Z",
    fill: "url(#paint13_linear_2009_39989)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M391.453 621.693C393.493 619.734 396.737 619.816 398.696 621.856C400.654 623.896 400.573 627.14 398.532 629.098C396.492 631.057 393.249 630.975 391.29 628.935C389.332 626.895 389.413 623.651 391.453 621.693Z",
    fill: "url(#paint14_linear_2009_39989)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M629.427 43.4922L666.658 92.2501C666.903 92.6173 667.168 92.9845 667.495 93.3109C670.106 96.0446 674.452 96.1466 677.185 93.5353C679.919 90.924 680.021 86.5787 677.41 83.845C677.104 83.5186 676.757 83.2125 676.39 82.9677L629.427 43.5126V43.4922Z",
    fill: "url(#paint15_linear_2009_39989)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M634.711 49.0234L667.372 91.7631C667.576 92.0895 667.821 92.3955 668.087 92.6811C670.371 95.068 674.166 95.17 676.553 92.8851C678.94 90.6003 679.042 86.8057 676.757 84.4188C676.471 84.1332 676.186 83.868 675.859 83.6436L634.69 49.0234H634.711Z",
    fill: "url(#paint16_linear_2009_39989)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M668.658 84.5944C670.759 82.5951 674.084 82.6767 676.084 84.7576C678.083 86.8588 678.001 90.1842 675.92 92.1835C673.819 94.1827 670.494 94.1011 668.494 92.0203C666.495 89.919 666.577 86.5936 668.658 84.5944Z",
    fill: "url(#paint17_linear_2009_39989)"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M834.7 658.904L800.834 671.247C699.891 506.47 534.869 414.299 534.869 414.299L576.16 340.203C576.16 340.203 772.906 447.409 834.7 658.884V658.904Z",
    fill: "url(#paint18_linear_2009_39989)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M649.868 434.94C614.534 341.158 565.205 358.947 565.205 358.947L553.413 379.45L553.291 379.654L541.499 400.157C541.499 400.157 550.945 451.75 649.766 435.124L650.011 435.267C650.011 435.267 649.97 435.165 649.95 435.103C650.011 435.103 650.072 435.103 650.134 435.083L649.889 434.94H649.868Z",
    fill: "url(#paint19_linear_2009_39989)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M552.161 326.844L510.868 400.941L534.872 414.318L576.165 340.221L552.161 326.844Z",
    fill: "#6928FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M427.969 308.971C388.147 380.414 412.75 470.015 482.949 509.102C499.27 518.181 516.59 523.689 534.094 525.974C497.25 480.786 489.824 415.279 520.385 360.442C550.965 305.584 610.597 277.431 668.413 284.959C657.274 271.29 643.463 259.458 627.142 250.359C556.943 211.271 467.771 237.527 427.949 308.971H427.969Z",
    fill: "url(#paint20_linear_2009_39989)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M543.07 329.802C575.793 295.488 622.654 279.024 668.413 284.981C657.274 271.313 643.463 259.48 627.142 250.381C568.163 217.557 495.802 230.858 450.553 278.31L543.05 329.802H543.07Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M342.061 365.89C401.978 399.245 463.976 416.871 518.406 419.136C521.935 402.244 528.035 385.536 536.909 369.623C545.784 353.71 556.78 339.736 569.285 327.842C538.704 282.818 491.069 239.384 431.172 206.029C336.023 153.048 235.508 139.665 168.654 164.595C182.629 234.529 246.912 312.888 342.061 365.869V365.89Z",
    fill: "url(#paint21_linear_2009_39989)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M227.694 275.008C232.652 280.822 236.65 284.739 236.65 284.739C236.65 285.025 266.741 213.071 308.257 159.417C308.257 159.417 297.241 157.152 293.589 156.785C261.233 166.659 216.8 230.024 227.674 274.987L227.694 275.008Z",
    fill: "#6928FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M501.351 372.314C540.928 394.347 579.078 406.445 601.559 405.649C590.4 386.105 560.044 360.053 520.466 338.02C480.889 315.987 442.739 303.89 420.257 304.685C431.417 324.229 461.793 350.281 501.351 372.314Z",
    fill: "url(#paint22_linear_2009_39989)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M600.478 405.649C600.825 405.649 601.213 405.649 601.559 405.649C590.4 386.105 560.044 360.053 520.466 338.02C480.889 315.987 442.739 303.89 420.257 304.685C420.441 304.991 420.665 305.297 420.829 305.603L600.499 405.628L600.478 405.649Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M227.756 275.062C237.201 255.151 247.524 234.852 258.724 214.758C269.924 194.663 281.614 175.282 293.589 156.779C246.585 149.087 203.111 151.76 168.654 164.612C175.856 200.661 196.481 239.157 227.756 275.062Z",
    fill: "url(#paint23_linear_2009_39989)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M259.846 212.82C270.72 193.439 282.022 174.69 293.609 156.779C246.606 149.087 203.132 151.76 168.675 164.612L259.866 212.82H259.846Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M316.132 246.73C307.869 261.52 312.99 280.146 327.536 288.245C342.082 296.345 360.606 290.877 368.847 276.087C377.089 261.296 371.989 242.67 357.443 234.571C342.918 226.492 324.374 231.939 316.132 246.73Z",
    fill: "url(#paint24_linear_2009_39989)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.22
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M168.654 164.61L535.461 372.372C535.95 371.454 536.42 370.556 536.909 369.638C545.784 353.726 556.78 339.751 569.285 327.858C538.704 282.833 491.069 239.4 431.172 206.044C336.023 153.064 235.855 139.619 168.654 164.61Z",
    fill: "#CFCFCF"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M318.661 229.896C301.26 243.054 297.812 267.821 310.97 285.223C324.129 302.624 348.895 306.072 366.297 292.914C383.699 279.755 387.147 254.989 373.988 237.587C360.83 220.185 336.063 216.737 318.661 229.896ZM360.504 237.444C373.744 247.399 376.396 266.189 366.44 279.408C356.485 292.628 337.695 295.301 324.476 285.345C311.236 275.389 308.584 256.6 318.539 243.381C328.495 230.14 347.284 227.488 360.504 237.444Z",
    fill: "url(#paint25_linear_2009_39989)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M328.658 293.377C328.842 292.336 329.821 291.643 330.861 291.826C331.902 292.01 332.595 292.989 332.412 294.03C332.228 295.07 331.249 295.764 330.208 295.58C329.168 295.396 328.474 294.417 328.658 293.377Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M318.641 287.752C318.825 286.711 319.804 286.018 320.844 286.201C321.885 286.385 322.578 287.364 322.395 288.405C322.211 289.445 321.232 290.139 320.192 289.955C319.151 289.771 318.457 288.792 318.641 287.752Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M307.298 270.33C307.482 269.29 308.461 268.596 309.502 268.779C310.542 268.963 311.236 269.942 311.052 270.983C310.868 272.023 309.889 272.717 308.849 272.533C307.808 272.35 307.115 271.37 307.298 270.33Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M311.358 279.752C311.542 278.711 312.521 278.018 313.561 278.201C314.602 278.385 315.295 279.364 315.112 280.405C314.928 281.445 313.949 282.139 312.908 281.955C311.868 281.771 311.174 280.792 311.358 279.752Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M305.87 260.025C306.054 258.985 307.033 258.291 308.073 258.475C309.114 258.658 309.808 259.638 309.624 260.678C309.44 261.719 308.461 262.412 307.421 262.229C306.38 262.045 305.687 261.066 305.87 260.025Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M309.706 248.534C310.746 248.677 311.46 249.656 311.317 250.696C311.174 251.737 310.195 252.451 309.155 252.308C308.114 252.165 307.4 251.186 307.543 250.145C307.686 249.105 308.665 248.391 309.706 248.534Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M315.03 238.358C316.071 238.501 316.785 239.48 316.642 240.52C316.499 241.561 315.52 242.275 314.479 242.132C313.439 241.989 312.725 241.01 312.868 239.97C313.01 238.929 313.99 238.215 315.03 238.358Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M332.126 226.487C333.166 226.63 333.88 227.609 333.738 228.649C333.595 229.69 332.616 230.404 331.575 230.261C330.535 230.118 329.821 229.139 329.964 228.099C330.106 227.058 331.086 226.344 332.126 226.487Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M322.823 230.827C323.864 230.97 324.578 231.949 324.435 232.989C324.292 234.03 323.313 234.744 322.272 234.601C321.232 234.458 320.518 233.479 320.661 232.438C320.804 231.398 321.783 230.684 322.823 230.827Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M342.367 224.772C343.408 224.915 344.122 225.894 343.979 226.935C343.836 227.975 342.857 228.689 341.816 228.546C340.776 228.403 340.062 227.424 340.205 226.384C340.348 225.343 341.327 224.629 342.367 224.772Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M356.383 229.162C356.199 230.203 355.22 230.897 354.179 230.713C353.139 230.529 352.445 229.55 352.629 228.51C352.812 227.469 353.792 226.776 354.832 226.959C355.873 227.143 356.566 228.122 356.383 229.162Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M366.399 234.811C366.216 235.851 365.237 236.545 364.196 236.361C363.156 236.178 362.462 235.199 362.646 234.158C362.829 233.118 363.808 232.424 364.849 232.608C365.889 232.791 366.583 233.77 366.399 234.811Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M377.722 252.233C377.538 253.273 376.559 253.967 375.519 253.783C374.478 253.6 373.784 252.62 373.968 251.58C374.152 250.539 375.131 249.846 376.171 250.029C377.212 250.213 377.905 251.192 377.722 252.233Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M373.682 242.807C373.499 243.847 372.52 244.541 371.479 244.357C370.439 244.174 369.745 243.195 369.929 242.154C370.112 241.114 371.092 240.42 372.132 240.604C373.172 240.787 373.866 241.767 373.682 242.807Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M379.15 262.537C378.966 263.578 377.987 264.272 376.947 264.088C375.906 263.904 375.213 262.925 375.396 261.885C375.58 260.844 376.559 260.151 377.599 260.334C378.64 260.518 379.334 261.497 379.15 262.537Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M375.314 274.019C374.274 273.876 373.56 272.897 373.703 271.856C373.846 270.816 374.825 270.102 375.865 270.245C376.906 270.388 377.62 271.367 377.477 272.407C377.334 273.448 376.355 274.162 375.314 274.019Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M369.99 284.202C368.949 284.06 368.235 283.08 368.378 282.04C368.521 281 369.5 280.286 370.541 280.428C371.581 280.571 372.295 281.55 372.152 282.591C372.01 283.631 371.03 284.345 369.99 284.202Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M352.894 296.05C351.854 295.907 351.14 294.928 351.282 293.888C351.425 292.847 352.404 292.133 353.445 292.276C354.485 292.419 355.199 293.398 355.056 294.438C354.914 295.479 353.934 296.193 352.894 296.05Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M362.197 291.726C361.156 291.583 360.442 290.604 360.585 289.563C360.728 288.523 361.707 287.809 362.748 287.952C363.788 288.095 364.502 289.074 364.359 290.114C364.216 291.155 363.237 291.869 362.197 291.726Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M342.653 297.788C341.612 297.646 340.898 296.666 341.041 295.626C341.184 294.585 342.163 293.871 343.204 294.014C344.244 294.157 344.958 295.136 344.815 296.177C344.673 297.217 343.693 297.931 342.653 297.788Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2009_39989",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(411.767 91.3566) rotate(7.22432) scale(587.624 571.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.438452,
    stopColor: "#3A1B85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2009_39989",
    x1: 836.944,
    y1: 315.678,
    x2: 892.482,
    y2: 302.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2009_39989",
    x1: 841.779,
    y1: 314.82,
    x2: 890.461,
    y2: 303.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2009_39989",
    x1: 871.276,
    y1: 313.936,
    x2: 883.389,
    y2: 310.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2009_39989",
    x1: 714.983,
    y1: 180.451,
    x2: 879.141,
    y2: 60.9665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#D7491A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D2DC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2009_39989",
    x1: 715.021,
    y1: 180.451,
    x2: 826.393,
    y2: 55.6705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2009_39989",
    x1: 807,
    y1: 488.157,
    x2: 811.923,
    y2: 487.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2009_39989",
    x1: 727.398,
    y1: 625.944,
    x2: 1020.46,
    y2: 492.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#D7491A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D2DC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2009_39989",
    x1: 727.4,
    y1: 625.847,
    x2: 1020.35,
    y2: 492.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2009_39989",
    x1: 757.819,
    y1: 484.15,
    x2: 780.102,
    y2: 478.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2009_39989",
    x1: 759.813,
    y1: 483.804,
    x2: 779.347,
    y2: 478.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2009_39989",
    x1: 771.975,
    y1: 483.477,
    x2: 776.649,
    y2: 482.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2009_39989",
    x1: 353.161,
    y1: 632.249,
    x2: 410.924,
    y2: 617.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2009_39989",
    x1: 358.302,
    y1: 631.357,
    x2: 408.952,
    y2: 618.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2009_39989",
    x1: 389.871,
    y1: 630.517,
    x2: 401.969,
    y2: 627.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2009_39989",
    x1: 629.427,
    y1: 95.4294,
    x2: 688.626,
    y2: 80.5289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2009_39989",
    x1: 634.69,
    y1: 94.5369,
    x2: 686.578,
    y2: 81.4735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2009_39989",
    x1: 667.045,
    y1: 93.6333,
    x2: 679.432,
    y2: 90.3867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2009_39989",
    x1: 557.807,
    y1: 370.79,
    x2: 794.129,
    y2: 632.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE461D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#FF9E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2009_39989",
    x1: 541.499,
    y1: 438.425,
    x2: 663.469,
    y2: 395.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2009_39989",
    x1: 408.911,
    y1: 525.974,
    x2: 719.761,
    y2: 453.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2009_39989",
    x1: 423.619,
    y1: 445.48,
    x2: 333.136,
    y2: 118.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2009_39989",
    x1: 420.257,
    y1: 405.686,
    x2: 607.632,
    y2: 317.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2009_39989",
    x1: 168.654,
    y1: 275.062,
    x2: 315.831,
    y2: 235.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2009_39989",
    x1: 312.181,
    y1: 291.993,
    x2: 383.841,
    y2: 273.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2009_39989",
    x1: 302.977,
    y1: 300.907,
    x2: 396.279,
    y2: 276.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#D7491A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D2DC3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2009_39989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1020,
    height: 683,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaketebg);
export default __webpack_public_path__ + "static/media/raketebg.fe0778adb72d3bc3d97e7a3d05b801b3.svg";
export { ForwardRef as ReactComponent };